import { fontstyle1 } from "../../../utils/fonts";

const Footer = () => {
  return (
    <div className="flex items-center justify-center mt-10" style={fontstyle1}>
      <footer className="text-center dark:white">
        &copy;2022 dofeedbackin | All rights reserved | Terms of use
      </footer>
    </div>
  );
};

export default Footer;
